module.exports = __webpack_public_path__ + "static/logo-principal-3-8c7d6e87165e6623fc7402bac9b883c3.png";